import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ShoppingBag, UtensilsCrossed } from "lucide-react";
export default function OrderDirectly() {
  return <section data-section-id="223952" id="call-to-action" className="bg-background text-foreground sticky bottom-0 z-50 w-full border-t border-border bg-background/95 shadow-2xl backdrop-blur-md">
      <div className="mx-auto w-full max-w-7xl px-4 py-4 md:px-8 md:py-5">
        <div className="flex flex-col items-center gap-4 md:flex-row md:justify-between">
          
          <div className="flex w-full justify-center md:w-auto md:justify-start">
            <div className="text-center md:text-left">
              <p className="font-sans text-sm font-medium text-foreground">
                For questions, call 786-382-6895 or email info@trusted-fl.com
              </p>
            </div>
          </div>

          <div className="flex w-full flex-col gap-3 sm:flex-row md:w-auto">
            <Button variant="outline" size="lg" className="w-full rounded-md border-2 border-border py-6 text-base font-bold transition-colors hover:border-primary hover:text-primary sm:w-auto" asChild>
              <Link href="https://trusted-fl.com/#our-inspection-services">
                <ShoppingBag className="mr-2 h-5 w-5" />
                View All Services
              </Link>
            </Button>
            
            <Button variant="default" size="lg" className="w-full rounded-md py-6 text-base font-bold shadow-lg shadow-primary/20 sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90" asChild>
              <Link href="https://trusted-fl.com/#schedule-your-inspection">
                <UtensilsCrossed className="mr-2 h-5 w-5" />
                Book Your Condo Inspection
              </Link>
            </Button>
          </div>
          
        </div>
      </div>
    </section>;
}